import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteClassCoachRole(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteClassCoachRole = (kiloClassCoachRoleId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`kilo-class-coach-roles/${kiloClassCoachRoleId}/`);
  };

  return useMutation(deleteClassCoachRole, {
    onSuccess: () => {
      queryClient.removeQueries({
        queryKey: ['classCoachRoles'],
      });
      queryClient.invalidateQueries({
        queryKey: ['classPayRateLookups'],
      });
    },
  });
}
